
const Announcement = () => {
  return (
    <div className="bg-gradient-to-r from-[#111111] to-[#1a1a1a] border-b border-yellow-400/20 py-2.5 sm:py-3">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="flex items-center gap-3 sm:gap-4">
          <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center bg-yellow-400/10 rounded-full border border-yellow-400/40">
            <i className="ri-notification-3-fill text-yellow-400 text-xs sm:text-sm"></i>
          </div>
          <div className="flex-1 overflow-hidden">
            <div className="animate-marquee whitespace-nowrap text-gray-300 text-xs sm:text-sm">
              🏆 Kingbet9 – Australia's Most Trusted Online Casino 2026! &nbsp;|&nbsp;
              🎰 Slot Welcome Bonus: 100% up to AUD $500 for new members! &nbsp;|&nbsp;
              🎲 New Live Casino tables now available 24/7! &nbsp;|&nbsp;
              🔥 Complete Easy Step Get Free AUD $100! &nbsp;|&nbsp;
              💰 Crypto deposits accepted – Bitcoin, ETH, USDT! &nbsp;|&nbsp;
              📱 Download the Kingbet9 App – Available on iOS &amp; Android! &nbsp;|&nbsp;
              🎁 Refer a Friend and earn up to AUD $300 bonus! &nbsp;|&nbsp;
              🔒 Licensed &amp; Regulated – Safe &amp; Secure Gaming in Australia!
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Announcement;
